import { Component } from '@angular/core';

@Component({
  selector: 'header-support',
  templateUrl: 'support-header.component.html',
  styleUrls: ['./support-header.component.css']
})

export class SupportHeaderComponent {

}
